import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { id as idDateLocale } from "date-fns/locale";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem("lng") || "id",
    fallbackLng: "en",
    // One translation file per language and no namespaces anywhere, so the
    // default ":" only ever does harm: i18next reads any colon in a key as a
    // namespace split and silently returns the part after it. That already
    // truncates the AWS validation and password-policy strings in the id file,
    // and it would eat the "Baris N:" prefix on backend validation errors.
    nsSeparator: false,
    react: {
      bindI18n: "languageChanged",
    },
  });

// Every react-datepicker in the app follows the app language: month and day
// names in the calendar, the field and the screen-reader labels. A picker's own
// `locale` prop does not reach those labels (react-datepicker v4 formats them
// with the default locale only), so this is set here once rather than per field.
registerLocale("id", idDateLocale);
const syncDatePickerLocale = (language) =>
  setDefaultLocale(language?.startsWith("id") ? "id" : "en");
syncDatePickerLocale(i18n.language || localStorage.getItem("lng") || "id");
i18n.on("languageChanged", syncDatePickerLocale);

export default i18n;
